// src/services/summarization.js
// Centralized Groq summarization utility for persistentHeader
import { summarizeWithGroq } from "../services/groq";

/**
 * Summarizes input for persistentHeader groqContext.
 * Guards against empty/invalid summaries.
 * @param {object} input - Data to summarize (park, alerts, weather, campgrounds, etc.)
 * @returns {Promise<string>} - The summary string, or previous summary if invalid.
 */
export async function summarizeForHeader(input) {
  // If input is empty/null/undefined or has no keys, skip summarization
  if (!input || (typeof input === "object" && Object.keys(input).length === 0)) {
    return null;
  }
  const summaryInput = JSON.stringify(input, null, 2);
  const systemPrompt = `Summarize this input.\n\nRules:\n- Be concise (1 short sentence).\n- Identify the main category and align the summary to it.\n- Output ONLY in this format, nothing else:\n<Category>: <concise one-sentence summary focusing on user intent for planning>\n\nCategories:\n- Trip details and logistics\n- Environmental and safety factors\n- Gear and physical readiness`;
  try {
    const summary = await summarizeWithGroq(summaryInput, {
      messages: [
        { role: "system", content: systemPrompt },
        { role: "user", content: summaryInput },
      ]
    });
    if (typeof summary === "string" && summary.trim().length > 0) {
      return summary.trim();
    }
    return null;
  } catch (err) {
    // Optionally log error
    return null;
  }
}
